import { w3cwebsocket as W3CWebSocket } from "websocket"

import { TerminalInformation, WebSocketMessage } from "types/payload"

export interface SocketPayload {
  type: string
  action: string
  body: {
    [x: string]: unknown
  }
}

export enum ReadyState {
  CLOSED = 3,
  OPEN = 1,
}

export const WEBSOCKET_OPEN_STATE = 1

export async function staging(
  client: W3CWebSocket
): Promise<boolean | unknown> {
  console.info("[ creating a new Websocket client...]")
  const clientState = new Promise((resolve) => {
    client.onerror = function () {
      return resolve(false)
    }
    client.onopen = function () {
      if (client.readyState === WEBSOCKET_OPEN_STATE) return resolve(true)
      else return resolve(false)
    }
    client.onclose = function () {
      return resolve(false)
    }
  })
  return await clientState
}

export const getWssHost = (): string => {
  return "wss://wss.medadom.com:8080"
}

// Messages accepted from the card reader socket. Anything else coming from
// the local websocket is ignored instead of being dispatched.
export const isWebSocketMessage = (data: unknown): data is WebSocketMessage => {
  if (!data || typeof data !== "object") return false
  const message = data as Record<string, unknown>
  return (
    typeof message.type === "string" &&
    typeof message.action === "string" &&
    (message.result === undefined || typeof message.result === "string")
  )
}

const TERMINAL_FIELDS = [
  "hostname",
  "api_lec_version",
  "websocket_version",
  "webbrowser_version",
  "os_name",
  "os_version",
  "type",
  "ipv6",
  "ipv4_public",
  "ipv4_private",
] as const
const MANAGEENGINE_FIELDS = ["host_id", "version"] as const
const TEAMVIEWER_FIELDS = ["host_id", "alias", "version", "type"] as const

const pickStrings = <K extends string>(
  source: unknown,
  keys: readonly K[],
): Partial<Record<K, string>> | undefined => {
  if (!source || typeof source !== "object") return undefined
  const record = source as Record<string, unknown>
  const picked: Partial<Record<K, string>> = {}
  keys.forEach((key) => {
    if (typeof record[key] === "string") picked[key] = record[key] as string
  })
  return Object.keys(picked).length > 0 ? picked : undefined
}

// Keeps only the fields the API expects for a terminal, so that the socket
// payload can never write arbitrary attributes on the terminal resource.
export const pickTerminalInformation = (
  payload: unknown,
): TerminalInformation => {
  const source = (payload || {}) as Record<string, unknown>
  return {
    terminal: pickStrings(source.terminal, TERMINAL_FIELDS),
    manageengine: pickStrings(source.manageengine, MANAGEENGINE_FIELDS),
    teamviewer: pickStrings(source.teamviewer, TEAMVIEWER_FIELDS),
  }
}
